var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessBlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 230,
    viewBox: "0 0 226 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 172,
    width: 24,
    height: 57,
    fill: "#F1F1F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 172,
    width: 24,
    height: 57,
    fill: "#F1F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 229H20",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208 229H184",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 107,
    width: 24,
    height: 15,
    fill: "#F1F1F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 107,
    width: 24,
    height: 15,
    fill: "#F1F1F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 107,
    width: 24,
    height: 6,
    fill: "#D5DBDB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 172,
    width: 24,
    height: 6,
    fill: "#D5DBDB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 107,
    width: 24,
    height: 6,
    fill: "#D5DBDB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 41,
    width: 34,
    height: 16,
    fill: "#FFA28A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 41,
    width: 34,
    height: 16,
    fill: "#FFA28A"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 172,
    width: 24,
    height: 6,
    fill: "#D5DBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225 143.096L204 172H225V143.096Z",
    fill: "#FF6138"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 122V147.491L19.5206 122H1Z",
    fill: "#FF6138"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3271 122L7 172H34.1935L70.5206 122H43.3271Z",
    fill: "#FF6138"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8198 122L56.4927 172H83.6862L120.013 122H92.8198Z",
    fill: "#FF6138"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.327 122L106 172H133.193L169.521 122H142.327Z",
    fill: "#FF6138"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.327 122L155 172H182.193L218.521 122H191.327Z",
    fill: "#FF6138"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225 78.096L204 107H225V78.096Z",
    fill: "#FF6138"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 57V82.4914L19.5206 57H1Z",
    fill: "#FF6138"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3271 57L7 107H34.1935L70.5206 57H43.3271Z",
    fill: "#FF6138"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8197 57L56.4926 107H83.686L120.013 57H92.8197Z",
    fill: "#FF6138"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.327 57L106 107H133.193L169.521 57H142.327Z",
    fill: "#FF6138"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.327 57L155 107H182.193L218.521 57H191.327Z",
    fill: "#FF6138"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 21,
    r: 20,
    fill: "#FAD000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 21,
    r: 20,
    fill: "#FAD000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 21,
    r: 12,
    fill: "#FEF2B8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 21,
    r: 6,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 30,
    r: 2,
    transform: "rotate(-180 41 30)",
    fill: "#FFA28A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 30,
    r: 2,
    transform: "rotate(-180 35 30)",
    fill: "#FFA28A"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 36,
    r: 2,
    transform: "rotate(-180 35 36)",
    fill: "#FFA28A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 36,
    r: 2,
    transform: "rotate(-180 29 36)",
    fill: "#FFA28A"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 24,
    r: 2,
    transform: "rotate(-180 35 24)",
    fill: "#FFA28A"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 24,
    r: 2,
    transform: "rotate(-180 41 24)",
    fill: "#FFA28A"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 24,
    r: 2,
    transform: "rotate(-180 47 24)",
    fill: "#FFA28A"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 18,
    r: 2,
    transform: "rotate(-180 47 18)",
    fill: "#FFA28A"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 18,
    r: 2,
    transform: "rotate(-180 41 18)",
    fill: "#FFA28A"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 12,
    r: 2,
    transform: "rotate(-180 41 12)",
    fill: "#FFA28A"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 30,
    r: 2,
    transform: "rotate(-180 29 30)",
    fill: "#FFA28A"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 21,
    r: 12,
    fill: "#FEF2B8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20 207L20 229",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20 172L20 198",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225 57L135 57",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77 57L1 57",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M126 57L85 57",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41H15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45H20",
    stroke: "#FFDAD1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M206 45H182",
    stroke: "#FFDAD1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M211 41H177",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M225 122L1.00001 122",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20 108L20 122",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15 41L15 55",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M177 41L177 55",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41L49 55",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M211 41L211 55",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1 57L1 107",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M225 75L225 107",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M225 57L225 65",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1 122L1 148",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1 154L1 162",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1 168L1 172",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M225 122L225 172",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M184 108L184 122",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44 108L44 122",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M208 108L208 122",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M184 172V213",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M184 221L184 229",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44 172L44 229",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M225 107L1.00001 107",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M225 172L1.00001 172",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M208 172V229",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 3.97469C24.5518 2.08852 28.1488 1 32 1C43.0457 1 52 9.9543 52 21C52 32.0457 43.0457 41 32 41C20.9543 41 12 32.0457 12 21C12 16.4967 13.4884 12.341 16 8.99805",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 3.97469C187.552 2.08852 191.149 1 195 1C206.046 1 215 9.9543 215 21C215 32.0457 206.046 41 195 41C183.954 41 175 32.0457 175 21C175 16.4967 176.488 12.341 179 8.99805",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 95,
    r: 5,
    fill: "#F1F1F2",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 95,
    r: 5,
    fill: "#F1F1F2",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 160,
    r: 5,
    fill: "#F1F1F2",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 160,
    r: 5,
    fill: "#F1F1F2",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 69,
    r: 5,
    fill: "#F1F1F2",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 69,
    r: 5,
    fill: "#F1F1F2",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 134,
    r: 5,
    fill: "#F1F1F2",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 134,
    r: 5,
    fill: "#F1F1F2",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 21,
    r: 6,
    fill: "white"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 30,
    r: 2,
    transform: "rotate(-180 204 30)",
    fill: "#FFA28A"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 30,
    r: 2,
    transform: "rotate(-180 198 30)",
    fill: "#FFA28A"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 36,
    r: 2,
    transform: "rotate(-180 198 36)",
    fill: "#FFA28A"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 36,
    r: 2,
    transform: "rotate(-180 192 36)",
    fill: "#FFA28A"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 24,
    r: 2,
    transform: "rotate(-180 198 24)",
    fill: "#FFA28A"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 24,
    r: 2,
    transform: "rotate(-180 204 24)",
    fill: "#FFA28A"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 24,
    r: 2,
    transform: "rotate(-180 210 24)",
    fill: "#FFA28A"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 18,
    r: 2,
    transform: "rotate(-180 210 18)",
    fill: "#FFA28A"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 18,
    r: 2,
    transform: "rotate(-180 204 18)",
    fill: "#FFA28A"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 12,
    r: 2,
    transform: "rotate(-180 204 12)",
    fill: "#FFA28A"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 30,
    r: 2,
    transform: "rotate(-180 192 30)",
    fill: "#FFA28A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessBlocked);
export default __webpack_public_path__ + "static/media/accessBlocked.4c4be3c78388ad4873c444aa6c33207c.svg";
export { ForwardRef as ReactComponent };